<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs ref="tabs">
      <TabPane :label="msgInstructionLabel" :disabled="isUpTab" name="up">
        <!-- 列数超过10给与固定宽度，否则自适应-->
        <Table
          :width="width"
          border
          stripe
          highlight-row
          ref="selection"
          :data="data"
          :columns="columns"
          :class="{ table: columns.length < 10 && showWidth }"
        ></Table>
        <Row style="padding-top: 15px;">
          <Col span="3">
            <Button type="primary" long @click="exportButton">
              <Icon type="ios-download-outline"></Icon>
              导出数据
            </Button>
          </Col>
          <Col span="10" offset="1">
            <Page
              :current="currentPage"
              :total="dataCount"
              :page-size="pageSize"
              show-sizer
              show-total
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            ></Page>
          </Col>
        </Row>
      </TabPane>
      <TabPane label="指令下发" name="down" :disabled="isDownTab">
        <div
          style="width:100%; left:10%; position:relative; margin-top:50px; margin-left:35px;"
        >
          <anchored-heading-forproduce
            :inputDatas="instructionInputList"
            @listenToChild3Next="listenToChild3EventNext"
            @input="inputFunc"
          ></anchored-heading-forproduce>
        </div>
      </TabPane>
    </Tabs>
    <Modal v-model="modalExport" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>选择导出列目</span>
      </p>
      <Form :label-width="120">
        <CheckboxGroup v-model="exportColumns">
          <FormItem v-for="value in exportTableColumns" :key="value.key">
            <Checkbox :label="value.key">
              {{ value.title }}
            </Checkbox>
          </FormItem>
        </CheckboxGroup>
      </Form>
      <div slot="footer">
        <Button
          type="success"
          size="large"
          long
          :loading="isLoadingButton"
          @click="exportException"
          >{{ exportMsg }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import Vue from "vue";
import expandExceptionRow from "../expand/tableExceptionExpand.vue";
import expandMonthRecordRow from "../expand/tableMonthRecordExpand.vue";
var inputObject = {};
var isNext = {};
export default {
  props: ["msgInstructionLabel", "msgInstructionUp", "speedGroup"],
  mounted() {},
  components: {
    expandExceptionRow,
    expandMonthRecordRow,
  },
  data() {
    return {
      exportMsg: "导出",
      exportTableColumns: [],
      exportTableData: [],
      exportColumns: [],
      modalExport: false,
      isLoadingButton: false,
      // 初始化信息总条数
      showWidth: true,
      dataCount: 0, // 每页显示多少条
      pageSize: 10, // 初始第一页
      currentPage: 1, // 遮罩
      isSpinShow: false,
      isUpTab: false,
      isDownTab: false,
      condition: {},
      data: [],
      columns: [],
      height: document.body.clientHeight,
      width: document.body.clientWidth * 0.8,
      instructionInputList: [],
      expandExceptionColumn: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandExceptionRow, {
              props: {
                row: params.row,
              },
            });
          },
        },
      ],
      expandMonthRecordColumn: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandMonthRecordRow, {
              props: {
                row: params.row,
              },
            });
          },
        },
      ],
    };
  },
  methods: {
    exportButton() {
      var that = this;
      that.isLoadingButton = true;
      that.modalExport = true;
      $.ajax({
        url: "/api/instructions/searchUpInstructions?page=1&pageAmount=1",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceId: that.condition.commandDeviceId,
          commandType: that.msgInstructionUp,
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.errorCode == 0) {
            that.exportTableColumns = receiveData.body.columns;
            if (that.msgInstructionLabel == "使用记录") {
              that.exportTableColumns = that.exportTableColumns
                .concat(that.exportTableColumns[1].children)
                .concat(that.exportTableColumns[2].children)
                .concat(that.exportTableColumns[3].children)
                .concat(that.exportTableColumns[4].children)
                .concat(that.exportTableColumns[5].children);
              that.exportTableColumns.splice(2, 4);
              that.exportTableColumns.splice(6, 0, {
                key: "record2",
                title: "记录二",
              });
              that.exportTableColumns.splice(11, 0, {
                key: "record3",
                title: "记录三",
              });
              that.exportTableColumns.splice(16, 0, {
                key: "record4",
                title: "记录四",
              });
              that.exportTableColumns.splice(21, 0, {
                key: "record5",
                title: "记录五",
              });
            }
          } else {
            that.$Notice.error({
              title: "异常",
              desc: receiveData.errorInfo,
            });
          }
          that.isLoadingButton = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
    },
    exportException() {
      var that = this;
      that.isLoadingButton = true;
      var total = 0;
      $.ajax({
        url:
          "/api/instructions/searchUpInstructions?page=0&pageAmount=" +
          this.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceFullId: that.condition.commandDeviceId,
          commandType: that.msgInstructionUp,
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.errorCode == 0) {
            that.exportTableData = receiveData.body.resultList;
            //that.exportTableColumns = receiveData.body.columns;
            total = receiveData.body.amount;
            setTimeout(() => {
              that.$refs.selection.exportCsv({
                filename: that.msgInstructionLabel,
                columns: that.exportTableColumns.filter(
                  (col, index) => that.exportColumns.indexOf(col.key) >= 0
                ),
                data: that.exportTableData.map((item, index) => {
                  //that.exportMsg = "导出中，请勿关闭(" + index + "/" + total +")";
                  if (that.msgInstructionLabel == "报警事件") {
                    if (item.alarmType == 1) {
                      item.alarmType = "报警";
                    } else if (item.alarmType == 0) {
                      item.alarmType = "解除";
                    }
                    item["errorNumberNo"] = item.errorNumber;
                    item.errorNumber =
                      global.errorMsgParam[item.errorNumber].name;
                    var error2Flags = parseInt(item.errorFlags).toString(2);
                    item.errorFlags = (Array(32).join("0") + error2Flags).slice(
                      -32
                    );
                  } else if (that.msgInstructionLabel == "使用记录") {
                    item.commandTimestamp = global.dateFtt(
                      "yyyy-MM-dd",
                      new Date(item.commandTimestamp)
                    );
                    that.exportTableColumns.map((paramT) => {
                      if (
                        paramT[paramT.key] &&
                        paramT[paramT.key].format &&
                        item[paramT[paramT.key].name] != null
                      ) {
                        item[paramT[paramT.key].name] = global.dateFtt(
                          paramT[paramT.key].format,
                          new Date(item[paramT[paramT.key].name])
                        );
                      }
                      return paramT;
                    });
                  }
                  Object.keys(item).map((param) => {
                    item[param] = "\t" + item[param];
                  });
                  return item;
                }),
              });
              that.isLoadingButton = false;
            }, 1);
          } else {
            that.$Notice.error({
              title: "异常",
              desc: receiveData.errorInfo,
            });
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
    },
    setGasApplianceSpeed() {
      console.log(this.instructionInputList);
      for (let i in this.instructionInputList) {
        if (
          this.instructionInputList[i]["name"] == "equipment1Velocity" &&
          this.speedGroup.speed1 != 0
        ) {
          this.instructionInputList[i]["default"] = this.speedGroup.speed1;
          this.instructionInputList[i]["value"] = this.speedGroup.speed1;
        }
        if (
          this.instructionInputList[i]["name"] == "equipment2Velocity" &&
          this.speedGroup.speed2 != 0
        ) {
          this.instructionInputList[i]["default"] = this.speedGroup.speed2;
          this.instructionInputList[i]["value"] = this.speedGroup.speed2;
        }
        if (
          this.instructionInputList[i]["name"] == "equipment3Velocity" &&
          this.speedGroup.speed3 != 0
        ) {
          this.instructionInputList[i]["default"] = this.speedGroup.speed3;
          this.instructionInputList[i]["value"] = this.speedGroup.speed3;
        }
      }
    },
    listenToChild3EventNext(param) {
      this.$emit("listenToChild3EventNext", param);
    },
    changePage(index) {
      this.currentPage = index;
      this.getInstructionList(this.condition);
    },
    changePageSize(size) {
      this.pageSize = size;
      this.getInstructionList(this.condition);
    },
    getInstructionList(param) {
      this.condition = param;
      this.condition["commandDeviceFullId"] = this.condition.commandDeviceId;
      this.condition["commandType"] = this.msgInstructionUp;
      this.condition["page"] = this.currentPage;
      this.condition["pageAmount"] = this.pageSize;

      //表单数据重置
      this.data = [];
      this.dataCount = 0;

      if (this.condition.commandType != "") {
        this.isUpTab = false;
        //查询表具信息
        if (this.isSpinShow == false) {
          this.isSpinShow = true;
        }
        var that = this;

        $.ajax({
          url:
            "/api/instructions/searchUpInstructions?page=" +
            this.currentPage +
            "&pageAmount=" +
            this.pageSize,
          contentType: "application/json",
          type: "post",
          data: JSON.stringify(that.condition),
          dataType: "json",
          success: function(receiveData) {
            console.log(receiveData);
            if (receiveData.errorCode == 0) {
              that.data = receiveData.body.resultList;
              that.dataCount = receiveData.body.amount;
              that.pageSize = receiveData.body.pageAmount;
              that.currentPage = receiveData.body.page;

              if (that.msgInstructionLabel == "报警事件") {
                that.data.map((val) => {
                  if (val.alarmType == 1) {
                    val.alarmType = "报警";
                  } else if (val.alarmType == 0) {
                    val.alarmType = "解除";
                  }
                  val["errorNumberNo"] = val.errorNumber;
                  val.errorNumber = global.errorMsgParam[val.errorNumber].name;
                  var error2Flags = parseInt(val.errorFlags).toString(2);
                  val.errorFlags = (Array(32).join("0") + error2Flags).slice(
                    -32
                  );
                  return val;
                });
                that.columns = that.expandExceptionColumn.concat(
                  receiveData.body.columns.map((val) => {
                    val.width = that.width * 0.125;
                    return val;
                  })
                );
                for (var i = that.columns.length - 1; i >= 0; i--) {
                  if (
                    that.columns[i].key == "currentRatio1" ||
                    that.columns[i].key == "currentRatio2" ||
                    that.columns[i].key == "currentRatio3" ||
                    that.columns[i].key == "currentRatio4" ||
                    that.columns[i].key == "factoryRatio1" ||
                    that.columns[i].key == "factoryRatio2" ||
                    that.columns[i].key == "factoryRatio3" ||
                    that.columns[i].key == "factoryRatio4" ||
                    that.columns[i].key == "interval" ||
                    that.columns[i].key == "isUsing" ||
                    that.columns[i].key == "isValveClosed" ||
                    that.columns[i].key == "velocity" ||
                    that.columns[i].key == "pipePressure" ||
                    that.columns[i].key == "atmosphericPressure" ||
                    that.columns[i].key == "pipeTemperature" ||
                    that.columns[i].key == "indoorTemperature" ||
                    that.columns[i].key == "lastTime" ||
                    that.columns[i].key == "param"
                  ) {
                    that.columns.splice(i, 1);
                  }
                }
              } else if (that.msgInstructionLabel == "月用气记录") {
                that.columns = that.expandMonthRecordColumn.concat(
                  receiveData.body.columns.map((val) => {
                    return val;
                  })
                );
                for (var i = that.columns.length - 1; i >= 0; i--) {
                  if (
                    that.columns[i].key == "record2Flow" ||
                    that.columns[i].key == "record2StandardFlow" ||
                    that.columns[i].key == "record2Time" ||
                    that.columns[i].key == "record2cost" ||
                    that.columns[i].key == "record3Flow" ||
                    that.columns[i].key == "record3StandardFlow" ||
                    that.columns[i].key == "record3Time" ||
                    that.columns[i].key == "record3cost" ||
                    that.columns[i].key == "record4Flow" ||
                    that.columns[i].key == "record4StandardFlow" ||
                    that.columns[i].key == "record4Time" ||
                    that.columns[i].key == "record4cost" ||
                    that.columns[i].key == "record5Flow" ||
                    that.columns[i].key == "record5StandardFlow" ||
                    that.columns[i].key == "record5Time" ||
                    that.columns[i].key == "record5cost" ||
                    that.columns[i].key == "record6Flow" ||
                    that.columns[i].key == "record6StandardFlow" ||
                    that.columns[i].key == "record6Time" ||
                    that.columns[i].key == "record6cost" ||
                    that.columns[i].key == "record7Flow" ||
                    that.columns[i].key == "record7StandardFlow" ||
                    that.columns[i].key == "record7Time" ||
                    that.columns[i].key == "record7cost" ||
                    that.columns[i].key == "record8Flow" ||
                    that.columns[i].key == "record8StandardFlow" ||
                    that.columns[i].key == "record8Time" ||
                    that.columns[i].key == "record8cost" ||
                    that.columns[i].key == "record9Flow" ||
                    that.columns[i].key == "record9StandardFlow" ||
                    that.columns[i].key == "record9Time" ||
                    that.columns[i].key == "record9cost" ||
                    that.columns[i].key == "record10Flow" ||
                    that.columns[i].key == "record10StandardFlow" ||
                    that.columns[i].key == "record10Time" ||
                    that.columns[i].key == "record10cost"
                  ) {
                    that.columns.splice(i, 1);
                  }
                }
              } else if (that.msgInstructionLabel == "使用记录") {
                that.showWidth = false;
                that.columns = receiveData.body.columns.map((val) => {
                  if (val.children) {
                    val.children.map((val) => {
                      val.width = that.width * 0.1;
                      return val;
                    });
                  } else {
                    val.width = that.width * 0.1;
                  }
                  return val;
                });
                that.data.map((val) => {
                  val.commandTimestamp = dateFtt(
                    "yyyy-MM-dd",
                    new Date(val.commandTimestamp)
                  );
                  that.columns.map((param) => {
                    if (param.children) {
                      param.children.map((paramT) => {
                        if (
                          paramT[paramT.key] &&
                          paramT[paramT.key].format &&
                          val[paramT[paramT.key].name] != null
                        ) {
                          val[paramT[paramT.key].name] = dateFtt(
                            paramT[paramT.key].format,
                            new Date(val[paramT[paramT.key].name])
                          );
                        }
                        return param;
                      });
                    }
                    return param;
                  });
                  return val;
                });
                console.log(that.columns);
              } else {
                that.columns = receiveData.body.columns.map((val) => {
                  val.width = that.width * 0.1;
                  return val;
                });
              }
            } else {
              that.$Notice.error({
                title: "异常",
                desc: receiveData.errorInfo,
              });
            }
            that.isSpinShow = false;
          },
          error: function(textStatus) {
            that.isSpinShow = false;
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常",
            });
          },
        });
      } else {
        this.isUpTab = true;
        this.$refs.tabs.activeKey = "down";
      }
    },
    getDownInstruction(param) {
      if (param.commandType != "") {
        this.isDownTab = false;
        //查询表具信息
        this.condition = param;
        var that = this;
        $.ajax({
          url: "/api/instructions/downInstruction",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify(that.condition),
          dataType: "json",
          success: function(receiveData) {
            if (receiveData.errorCode == 0) {
              inputObject = {};
              isNext = {};
              that.instructionInputList = receiveData.body;
              that.instructionInputList.map((inputData) => {
                if (
                  inputData.default !== null &&
                  inputData.default !== undefined &&
                  inputData.default !== NaN &&
                  inputData.default !== ""
                ) {
                  isNext[inputData.name] = true;
                  if (inputData.dataType == "uint" && !inputData.selection) {
                    inputObject[inputData.name] = inputData.default * 1;
                  } else if (
                    inputData.dataType == "uint" &&
                    inputData.selection
                  ) {
                    inputObject[inputData.name] = inputData.default * 1;
                  } else if (inputData.dataType == "string") {
                    inputObject[inputData.name] = inputData.default;
                  } else if (inputData.dataType == "timeStamp") {
                    inputObject[inputData.name] = inputData.default;
                  } else if (inputData.dataType == "bool") {
                    inputObject[inputData.name] = inputData.default;
                  }
                } else {
                  isNext[inputData.name] = false;
                }
                //                                console.log(inputData.name + " "+ inputData.default + " " + typeof(inputData.default));
                //                                console.log(isNext[inputData.name]);
              });
              that.$emit("listenToChild3Event", inputObject);
              that.$emit("listenToChild3EventNext", isNextAvaliable());
            } else {
              that.$Notice.error({
                title: "异常",
                desc: receiveData.errorInfo,
              });
            }
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常",
            });
          },
        });
      } else {
        this.isDownTab = true;
        this.$refs.tabs.activeKey = "up";
      }
    },
    inputFunc(value) {
      console.log(value);
      console.log(isNext);
      this.$emit("listenToChild3Event", value);
    },
    isShowSpin(param) {
      this.isSpinShow = param;
    },
  },
};

Vue.component("anchored-heading-forproduce", {
  render: function(createElement) {
    var self = this;
    var elementExport;
    if (this.inputDatas.length) {
      console.log(this.inputDatas.length);
      this.isDownTab = true;
      var brCount = true;
      return createElement(
        "div",
        this.inputDatas.map(function(inputData) {
          inputData.value = inputData.default;
          var inputType = "";
          if (inputData.dataType == "uint" && !inputData.selection) {
            inputType = "number";
            inputObject[inputData.name] = parseInt(inputData.default);
          } else if (inputData.dataType == "uint" && inputData.selection) {
            inputType = "selection";
            inputObject[inputData.name] = inputData.default * 1;
          } else if (inputData.dataType == "string") {
            inputType = "text";
            inputObject[inputData.name] = inputData.default;
          } else if (inputData.dataType == "timeStamp") {
            inputType = "datetime-local";
            //inputObject[inputData.name] = inputData.default;
          } else if (inputData.dataType == "bool") {
            inputObject[inputData.name] = inputData.default;
          }

          //输入框
          var elementInput = createElement(
            "Input",
            {
              // DOM属性
              props: {
                id: inputData.name,
                value: inputData.value,
                max: inputData.max,
                min: inputData.min,
                type: inputType,
              },

              style: {
                display: "inline-block",
                fontSize: "15px",
                width: "150px",
                height: "20px",
              },
              on: {
                input: function(event) {
                  if (inputData.dataType == "uint") {
                    inputData.default = event;
                    inputObject[inputData.name] = parseInt(event);
                    self.$emit("input", inputObject);
                  } else if (inputData.dataType == "string") {
                    inputData.default = event;
                    inputObject[inputData.name] = event;
                    self.$emit("input", inputObject);
                  } else if (inputData.dataType == "timeStamp") {
                    inputData.default = event;
                    inputObject[inputData.name] = dateFtt(
                      "yyyy-MM-dd hh:mm:ss",
                      event
                    );
                    self.$emit("input", inputObject);
                  }
                  if (event != null && event != "") {
                    isNext[inputData.name] = true;
                  } else {
                    isNext[inputData.name] = false;
                  }
                  self.$emit("listenToChild3Next", isNextAvaliable());
                },
                "on-blur": function(event) {
                  if (inputData.dataType == "uint") {
                    if (
                      inputData.max >= 0 &&
                      parseInt(event.target.value) > inputData.max
                    ) {
                      inputData.default = inputData.max;
                      inputObject[inputData.name] = inputData.default;
                      self.$emit("input", inputObject);
                      isNext[inputData.name] = true;
                      console.log(222);
                      self.$emit("listenToChild3Next", isNextAvaliable());
                    } else if (
                      inputData.min >= 0 &&
                      (parseInt(event.target.value) < inputData.min ||
                        event.target.value == "")
                    ) {
                      inputData.default = inputData.min;
                      inputObject[inputData.name] = inputData.default;
                      self.$emit("input", inputObject);
                      isNext[inputData.name] = true;
                      console.log(333);
                      self.$emit("listenToChild3Next", isNextAvaliable());
                    }
                  } else if (inputData.dataType == "string") {
                  } else if (inputData.dataType == "timeStamp") {
                  }
                },
              },
            },
            inputData.default
          );

          //小tips

          if (inputData.name == "address") {
            inputData.default = "sg.cnzhuocheng.cn";
            inputData.value = inputData.default;
            elementInput = createElement(
              "Input",
              {
                // DOM属性
                props: {
                  id: inputData.name,
                  value: inputData.value,
                  max: inputData.max,
                  min: inputData.min,
                  type: "password",
                  readonly: true,
                },
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  width: "150px",
                  height: "20px",
                },
                on: {
                  input: function(event) {
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                  "on-blur": function(event) {
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                },
              },
              inputData.default
            );
            elementInput = createElement(
              "Tooltip",
              {
                props: {
                  maxWidth: "200",
                  content: "生产环境地址不可更改！",
                  transfer: true,
                  placement: "right",
                },
              },
              [elementInput]
            );
          }

          if (inputData.name == "port") {
            inputData.default = "80";
            inputData.value = inputData.default;
            elementInput = createElement(
              "Input",
              {
                // DOM属性
                props: {
                  id: inputData.name,
                  value: inputData.value,
                  max: inputData.max,
                  min: inputData.min,
                  type: "password",
                  readonly: true,
                },

                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  width: "150px",
                  height: "20px",
                },
                on: {
                  input: function(event) {
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                  "on-blur": function(event) {
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                },
              },
              inputData.default
            );
            elementInput = createElement(
              "Tooltip",
              {
                props: {
                  maxWidth: "200",
                  content: "生产环境端口不可更改！",
                  transfer: true,
                  placement: "right",
                },
              },
              [elementInput]
            );
          }

          var nowOptions = {
            shortcuts: [
              {
                text: "一周前",
                value() {
                  const date = new Date();
                  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                  return date;
                },
              },
              {
                text: "昨天",
                value() {
                  const date = new Date();
                  date.setTime(date.getTime() - 3600 * 1000 * 24);
                  return date;
                },
              },
              {
                text: "现在",
                value() {
                  const date = new Date();
                  return date;
                },
              },
              {
                text: "明天",
                value() {
                  const date = new Date();
                  date.setTime(date.getTime() + 3600 * 1000 * 24);
                  return date;
                },
              },
              {
                text: "一周后",
                value() {
                  const date = new Date();
                  date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                  return date;
                },
              },
            ],
          };
          //时间选择器
          var elementDatePicker = createElement("DatePicker", {
            // DOM属性
            props: {
              id: inputData.name,
              value: inputData.value,
              type: "datetime",
              placeholder: "选择时间",
              transfer: true,
              options: nowOptions,
            },
            style: {
              display: "inline-block",
              fontSize: "15px",
              width: "150px",
              height: "20px",
            },
            on: {
              "on-change": function(event) {
                if (inputData.dataType == "timeStamp") {
                  inputData.default = event;
                  inputObject[inputData.name] = event;
                  self.$emit("input", inputObject);
                }
                if (event != null && event != "" && event != undefined) {
                  isNext[inputData.name] = true;
                } else {
                  isNext[inputData.name] = false;
                }
                self.$emit("listenToChild3Next", isNextAvaliable());
              },
            },
          });

          //选择器
          var selectBool = [
            {
              value: true,
              label: "是",
            },
            {
              value: false,
              label: "否",
            },
          ];

          if (inputData.cnName == "特征值(标定/复核)") {
            selectBool = [
              {
                value: true,
                label: "标定",
              },
              {
                value: false,
                label: "复核",
              },
            ];
          }

          var elementSelectBool = createElement(
            "Select",
            {
              // DOM属性
              props: {
                value: (inputData.default || false).toString(),
                transfer: true,
              },
              domProps: {},
              style: {
                display: "inline-block",
                fontSize: "15px",
                width: "150px",
                height: "20px",
              },
              on: {
                "on-change": function(event) {
                  inputData.default = event;
                  inputObject[inputData.name] = event === "true";
                  self.$emit("input", inputObject);
                  isNext[inputData.name] = true;
                  self.$emit("listenToChild3Next", isNextAvaliable());
                },
              },
            },
            selectBool.map((item) => {
              return createElement("Option", {
                props: {
                  value: (item.value || false).toString(),
                  label: item.label,
                },
              });
            })
          );

          //小tips

          //选择器
          var selectBanCancel = [
            {
              value: 20,
              label: "计量精度下降",
            },
            {
              value: 6,
              label: "气表损坏",
            },
          ];

          var elementSelectBanCancel = createElement(
            "Select",
            {
              // DOM属性
              props: {
                value: inputData.default,
                transfer: true,
              },
              domProps: {},
              style: {
                display: "inline-block",
                fontSize: "15px",
                width: "150px",
                height: "20px",
              },
              on: {
                "on-change": function(event) {
                  inputData.default = event;
                  inputObject[inputData.name] = event;
                  self.$emit("input", inputObject);
                  if (event != undefined) {
                    isNext[inputData.name] = true;
                  } else {
                    isNext[inputData.name] = false;
                  }
                  self.$emit("listenToChild3Next", isNextAvaliable());
                },
              },
            },
            selectBanCancel.map((item) => {
              return createElement("Option", {
                props: {
                  value: item.value,
                  label: item.label,
                },
              });
            })
          );

          var elementSpace = createElement("label", {
            style: {
              display: "inline-block",
              fontSize: "15px",
              minWidth: "5px",
              verticalAlign: "middle",
              overflow: "hidden",
            },
          });

          var elementUnit = createElement(
            "label",
            {
              style: {
                display: "inline-block",
                fontSize: "15px",
                maxWidth: "100px",
                verticalAlign: "middle",
                overflow: "hidden",
              },
            },
            inputData.unit
          );

          var hourOptions = [
            {
              value: 0,
              label: "0",
            },
            {
              value: 1,
              label: 1,
            },
            {
              value: 2,
              label: 2,
            },
            {
              value: 3,
              label: 3,
            },
            {
              value: 4,
              label: 4,
            },
            {
              value: 5,
              label: 5,
            },
            {
              value: 6,
              label: 6,
            },
            {
              value: 7,
              label: 7,
            },
            {
              value: 8,
              label: 8,
            },
            {
              value: 9,
              label: 9,
            },
            {
              value: 10,
              label: 10,
            },
            {
              value: 11,
              label: 11,
            },
            {
              value: 12,
              label: 12,
            },
            {
              value: 13,
              label: 13,
            },
            {
              value: 14,
              label: 14,
            },
            {
              value: 15,
              label: 15,
            },
            {
              value: 16,
              label: 16,
            },
            {
              value: 17,
              label: 17,
            },
            {
              value: 18,
              label: 18,
            },
            {
              value: 19,
              label: 19,
            },
            {
              value: 20,
              label: 20,
            },
            {
              value: 21,
              label: 21,
            },
            {
              value: 22,
              label: 22,
            },
            {
              value: 23,
              label: 23,
            },
          ];

          var minOptions = [
            {
              value: 0,
              label: "0",
            },
            {
              value: 1,
              label: 10,
            },
            {
              value: 2,
              label: 20,
            },
            {
              value: 3,
              label: 30,
            },
            {
              value: 4,
              label: 40,
            },
            {
              value: 5,
              label: 50,
            },
          ];

          //自定义时间组件 135代表13点50分
          var elementTime = [
            //小时
            createElement(
              "Select",
              {
                // DOM属性
                props: {
                  value: Math.floor(inputData.default / 10),
                  transfer: true,
                },
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  width: "85px",
                  height: "20px",
                },
                on: {
                  "on-change": function(event) {
                    inputData.default = event * 10 + (inputData.default % 10);
                    inputObject[inputData.name] = inputData.default;
                    self.$emit("input", inputObject);
                    isNext[inputData.name] = true;
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                },
              },
              hourOptions.map((item) => {
                return createElement("Option", {
                  props: {
                    value: item.value,
                    label: item.label,
                  },
                });
              })
            ),
            //空格
            createElement("label", {
              style: {
                display: "inline-block",
                fontSize: "15px",
                minWidth: "5px",
                verticalAlign: "middle",
                overflow: "hidden",
              },
            }),
            createElement(
              "label",
              {
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  maxWidth: "50px",
                  verticalAlign: "middle",
                  overflow: "hidden",
                },
              },
              inputData.unit
            ),
            //分
            createElement(
              "Select",
              {
                // DOM属性
                props: {
                  value: inputData.default % 10,
                  transfer: true,
                },
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  width: "85px",
                  height: "20px",
                },
                on: {
                  "on-change": function(event) {
                    var hour = Math.floor(inputData.default / 10) * 10;
                    inputData.default = hour + event;
                    inputObject[inputData.name] = inputData.default;
                    self.$emit("input", inputObject);
                    isNext[inputData.name] = true;
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                },
              },
              minOptions.map((item) => {
                return createElement("Option", {
                  props: {
                    value: item.value,
                    label: item.label,
                  },
                });
              })
            ),
            //空格
            createElement("label", {
              style: {
                display: "inline-block",
                fontSize: "15px",
                minWidth: "5px",
                verticalAlign: "middle",
                overflow: "hidden",
              },
            }),
            createElement(
              "label",
              {
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  maxWidth: "50px",
                  verticalAlign: "middle",
                  overflow: "hidden",
                },
              },
              "分"
            ),
          ];

          if (inputData.dataType == "bool") {
            elementExport = elementSelectBool;
          } else if (inputData.dataType == "timeStamp") {
            elementExport = elementDatePicker;
          } else if (inputData.cnName == "故障类型") {
            elementExport = elementSelectBanCancel;
          } else if (inputData.dataType == "uint" && inputData.selection) {
            elementExport = createElement(
              "Select",
              {
                // DOM属性
                props: {
                  value: inputData.default,
                  transfer: true,
                },
                domProps: {},
                style: {
                  display: "inline-block",
                  fontSize: "15px",
                  width: "150px",
                  height: "20px",
                },
                on: {
                  "on-change": function(event) {
                    inputData.default = event;
                    inputObject[inputData.name] = event;
                    self.$emit("input", inputObject);
                    if (event != undefined) {
                      isNext[inputData.name] = true;
                    } else {
                      isNext[inputData.name] = false;
                    }
                    self.$emit("listenToChild3Next", isNextAvaliable());
                  },
                },
              },
              inputData.selection.map((item) => {
                return createElement("Option", {
                  props: {
                    value: item.value,
                    label: item.label,
                  },
                });
              })
            );
          } else {
            elementExport = elementInput;
          }
          if (inputData.tip) {
            elementExport = createElement(
              "Tooltip",
              {
                props: {
                  maxWidth: "200",
                  content: inputData.tip,
                  transfer: true,
                  placement: "right",
                },
              },
              [elementExport]
            );
          }

          if (
            inputData.dataType != "timeStamp" &&
            inputData.name.toLowerCase().search("time") != -1
          ) {
            elementExport = null;
            elementSpace = null;
            elementUnit = null;
          } else {
            elementTime = null;
          }

          var widthStyle = "";
          if (document.body.clientWidth > 1000) {
            widthStyle = "40%";
          } else {
            widthStyle = "80%";
          }
          return createElement(
            "div", // 标签名称
            {
              style: {
                float: "left",
                width: widthStyle,
                height: "35px",
              },
            },
            [
              // 输入框中文名
              createElement(
                "label",
                {
                  style: {
                    display: "inline-block",
                    fontSize: "15px",
                    width: "150px",
                    verticalAlign: "middle",
                    overflow: "hidden",
                  },
                },
                inputData.cnName
              ),
              //输入框
              elementExport,
              // 空格
              elementSpace,
              //单位
              elementUnit,
            ].concat(elementTime)
          );
        })
      );
    } else {
      this.isDownTab = true;
      return createElement("p", "确认重置请直接下一步，否则请返回");
    }
  },
  props: ["inputDatas"],
});
var getChildrenTextContent = function(children) {
  return children
    .map(function(node) {
      return node.children ? getChildrenTextContent(node.children) : node.text;
    })
    .join("");
};

/**************************************时间格式化处理************************************/
function dateFtt(fmt, date) {
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (date.getFullYear() == 1970) {
    return null;
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

function isNextAvaliable() {
  var temp = true;
  for (var val in isNext) {
    temp = temp && isNext[val]; //输出如:name
  }
  return temp;
}
</script>
<style>
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.table table {
  table-layout: auto;
  width: 100% !important;
}
</style>
